import { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';

import { api } from '../../../lib/api.js';
import { WorkspaceDetail } from '@raven/shared-types';

export function SettingsPage() {
  const { id } = useParams({ strict: false }) as { id: string };
  const qc = useQueryClient();
  const detail = useQuery({
    queryKey: ['workspace', id],
    queryFn: () => api.get(`/api/workspaces/${encodeURIComponent(id)}`, WorkspaceDetail),
  });
  const [pocName, setPocName] = useState('');
  const [pocEmail, setPocEmail] = useState('');
  const save = useMutation({
    mutationFn: () =>
      api.patch(`/api/workspaces/${encodeURIComponent(id)}`, {
        poc_name: pocName || undefined,
        poc_email: pocEmail || undefined,
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['workspace', id] }),
  });

  if (detail.isPending) return <div className="card text-sm text-slate-500">Loading…</div>;
  const ws = detail.data!;

  return (
    <div className="card max-w-2xl">
      <h3 className="text-base font-semibold">Workspace settings</h3>
      <div className="mt-4 space-y-3">
        <label className="block">
          <span className="text-sm font-medium">POC name</span>
          <input
            className="input mt-1"
            defaultValue={ws.poc_name ?? ''}
            onChange={(e) => setPocName(e.target.value)}
          />
        </label>
        <label className="block">
          <span className="text-sm font-medium">POC email</span>
          <input
            className="input mt-1"
            type="email"
            defaultValue={ws.poc_email ?? ''}
            onChange={(e) => setPocEmail(e.target.value)}
          />
        </label>
        <button
          className="btn-primary"
          disabled={save.isPending}
          onClick={() => save.mutate()}
        >
          {save.isPending ? 'Saving…' : 'Save'}
        </button>
        {save.error && (
          <p className="text-sm text-red-600">{(save.error as Error).message}</p>
        )}
      </div>
    </div>
  );
}
